import { render, staticRenderFns } from "./SubmitDraftDialog.vue?vue&type=template&id=6ce5e32e&"
import script from "./SubmitDraftDialog.vue?vue&type=script&lang=js&"
export * from "./SubmitDraftDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports